import { createAsyncThunk } from '@reduxjs/toolkit';

import { notificationPageSize } from '../../conts/notificationsConst';
import { NotificationResponse } from '../../types/NotificationsSchema';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const fetchNotifications = createAsyncThunk<
    NotificationResponse,
    void,
    ThunkConfig<string>
>('notifications/fetchNotifications', async (_, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
        const response = await extra.api.get<NotificationResponse>(
            `/v1/users/notifications`,
            {
                params: { pageSize: notificationPageSize, page: 1 },
            },
        );

        return response.data;
    } catch (e) {
        return rejectWithValue('error');
    }
});
